import React, { useState } from "react";
import "./AnnouncementType.scss";
import Modal from "@mui/material/Modal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PropertyApi } from "../../../../utils/api/Property";
import { CommonEnums } from "../../../../enums/common.enums";
import toast from "react-hot-toast";

const AnnouncementType: React.FC = () => {
  const [processingModalOpen, setProcessingModalOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleCreateAnnouncementPost = async (type: string) => {
    setProcessingModalOpen(true);
    setIsProcessing(true);

    try {
      const payload = { announcement_type: type };
      const existingId = searchParams.get("announcement_post_id");
      let res;

      if (existingId) {
        res = await PropertyApi.updateAnnouncementPost(payload, existingId);
      } else {
        res = await PropertyApi.createAnnouncementPost(payload);
      }

      const data = res?.data?.data;

      if (data?._id) {
        setSearchParams((prev) => {
          const next = new URLSearchParams(prev);
          next.set("announcement_post_id", data._id);
          next.set("announcement_type", type);
          next.set(
            "step",
            CommonEnums.announcementPostTabs.select_template.key
          );
          return next;
        });
      } else {
        toast.error("Something went wrong while saving the announcement post.");
      }
    } catch (err) {
      console.error("❌ Error saving announcement post:", err);
      toast.error("Error while saving announcement post");
    } finally {
      setIsProcessing(false);
      setProcessingModalOpen(false);
    }
  };

  return (
    <div className="announcement-type-tab">
      <div className="section">
        <p className="section-description">Select Announcement Type</p>
        <div className="button-group">
          {Object.values(CommonEnums.announcement_post_types).map((item) => (
            <button
              key={item.slug}
              className="review-type-btn"
              onClick={() => handleCreateAnnouncementPost(item.slug)}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <Modal
        open={processingModalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") setProcessingModalOpen(false);
        }}
        aria-labelledby="processing-modal"
        className="add-property-modal styled-modal"
        disableEscapeKeyDown
      >
        <div className="modal-center-wrapper">
          <div className="loading-content-wrapper">
            {isProcessing && (
              <div className="loading-container">
                <div className="spinner" />
                <p className="loading-text">
                  Processing your request
                  <br />
                  Please wait...
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AnnouncementType;
